import { SemanticProjectChangeStatus, SemanticProjectId } from "@hex/common";
import { EmptyObject, ValueOf } from "type-fest";

import { ContextWorkbenchFile } from "./contextWorkbenchFile";

type AnyObject = Record<string, unknown>;

export namespace ContextWorkbenchUnifiedPreview {
  export type ResourceGroup =
    | ResourceGroup.FileGroup
    | ResourceGroup.SemanticProjectGroup;

  export namespace ResourceGroup {
    export const Type = {
      Files: "files",
      SemanticProject: "semanticProject",
    } as const;
    export type Type = ValueOf<typeof Type>;

    type _Base<
      TType extends ResourceGroup.Type,
      TProperties extends AnyObject = EmptyObject,
    > = {
      type: TType;
      key: string;
      label: string;
    } & TProperties;

    export type FileGroup = _Base<
      "files",
      {
        files: ContextWorkbenchFile.EntityWithDiff[];
        warning?: string;
      }
    >;

    export type SemanticProjectGroup = _Base<
      "semanticProject",
      {
        semanticProjectId: SemanticProjectId;
        status: SemanticProjectChangeStatus;
      }
    >;
  }

  export type Resources = {
    groups: ResourceGroup[];
    editedFileCount: number;
  };
}
